﻿import * as Clipboard from 'clipboard';

(function ($) {
    //Decalare in Global Namespace	
    window.M2 = window.M2 || {};
    window.M2.AddressBook = {};

    function resetAddAddressOverlay() {
        $(document).on("click", "#add-addresses-overlay .close-modal, .close-reveal-modal", function (e) {
            e.preventDefault();
            $("#imported-contacts .contacts.data tbody tr").not(".last").remove();
            $("#add-addresses-overlay form").trigger("reset");
        });
    }

    function copyToClipBoard(elem) {
        if (Clipboard.isSupported()) {
            try {
                var clipboard = new Clipboard(elem);
                clipboard.on('success', function (e) {
                    var button = $(e.trigger);
                    $('<div/>').addClass("copied-msg").text("Copied!").insertAfter(button).fadeOut(2000, function () { $(this).remove(); });
                });
            } catch (e) {
                console.log(e);
            }
        } else {
            $(elem).addClass('hidden');
        }
    }

    function setMarkAsSent() {
        M2.Util.onSwitchesProcessed().then(() => {
            const switchId = M2.AddressBook.config.markAsSentSwitchId;
            const switchObj = M2.Util.getSwitch(switchId);
            const $switch = $("#" + switchId);



            if (switchObj) {
                switchObj.onChangeSuccess = function (state) {
                    const tmpURL = $(M2.AddressBook.config.markAsSentId).val();
                    const token = $(M2.AddressBook.config.markAsSentId).closest("form").find("input[name='__RequestVerificationToken']").val();
                    $.ajax({
                        url: tmpURL,
                        type: 'POST',
                        data: {
                            markAsSent: state,
                            '__RequestVerificationToken': token
                        },
                        success: function (data) {
                            const addressBookRefreshURL = window.parent.$("#refresh-address-book-url").val();

                            $.ajax({
                                url: addressBookRefreshURL
                            }).done(function (data) {
                                window.parent.$("#address-book").html(data);
                            });
                        },
                        error: function (jqXHR, textStatus, errorMessage) {
                            console.log(errorMessage);
                        }
                    });

                }
            }
        });
    }

    function setAgreeToLastName() {
        $(document).on('click', '.agree-last-name', function (e) {
            var $displayLastNameCheckbox = $('#DisplayLastNameOnEmails');
            if (!$displayLastNameCheckbox.prop('checked')) $displayLastNameCheckbox.trigger('click');
        });

        $(document).on("click", ".cancel-last-name", function (e) {
            e.preventDefault();
            const $preferredOption = $('input[value=last-name]');

            $('.modal').modal('hide');
            // Reset the preferred Radio
            $preferredOption.prop('checked', true);
        });

        $(document).on('click', '.update-last-name.btn', function (e) {
            e.preventDefault();

            var $displayLastNameHidden = $('#DisplayLastNameOnEmails');
            var $preferredOption = $('input[value=last-name]');
            
            var useLastName = $(this).closest('#last-name-email-settings-modal').find('input[name=last-name-setting]:checked').val() === 'last-name' ? true : false;
            
            $('.name-setting-content').addClass('hidden');          
            if (useLastName) {
                $('.allow-last-name').removeClass('hidden');
                $displayLastNameHidden.val('True');
            } else {
                $('.disallow-last-name').removeClass('hidden');
                $displayLastNameHidden.val('False');
            }

            $('.modal').modal('hide');

            // Reset the preferred Radio
            $preferredOption.prop('checked', true);
        });
    }
    function setConfigOptions() {
        // Set config options
        /* global M2_greetingDefaultExampleText, M2_queuedEmailMessageText, M2_deleteEmailWarningTextStart, M2_deleteEmailWarningTextEnd, M2_AddressBook_goalAmount   */

        if ('undefined' !== typeof M2_greetingDefaultExampleText) M2.AddressBook.config.greetingDefaultExampleText = M2_greetingDefaultExampleText;
        if ('undefined' !== typeof M2_queuedEmailMessageText) M2.AddressBook.config.queuedEmailMessageText = M2_queuedEmailMessageText;
        if ('undefined' !== typeof M2_deleteEmailWarningTextStart) M2.AddressBook.config.deleteEmailWarningTextStart = M2_deleteEmailWarningTextStart;
        if ('undefined' !== typeof M2_deleteEmailWarningTextEnd) M2.AddressBook.config.deleteEmailWarningTextEnd = M2_deleteEmailWarningTextEnd;
        if ('undefined' !== typeof M2_AddressBook_goalAmount) M2.AddressBook.config.goalAmount = M2_AddressBook_goalAmount;
    }

    function setProductOrderQuery() {
        var productCheck = $('#check-product-orders').val();
        var activeToggleClass = 'active-girl-delivered-toggle';
        if (productCheck) {
            var isProductCheck = (productCheck.toLowerCase() === 'true');
            if (isProductCheck) {
                $(document).on('change', 'input.check-orders', function (e) {
                    if (!this.checked) {
                        var endpoint = $(this).data('check-orders-endpoint');
                        var modalTitle = $(this).data('modal-title');
                        var modalContent = $(this).data('modal-content');

                        // Check if orders exist for products
                        $.ajax({
                            url: endpoint
                        }).done(function (data) {
                            var showModal = data.showPopup;
                            if (showModal) {
                                // Remove any previously selected toggles.
                                $('input.check-orders').removeClass(activeToggleClass);

                                // Set the current checkbox as the active one
                                $(this).addClass(activeToggleClass);

                                // Check the box again, user must confirm the choice
                                $(this).prop('checked', true);

                                // Open the Modal
                                M2.Modal.create('disable-girl-delivered-prompt', modalTitle, modalContent, null, true);
                            }
                        });
                    }
                });

                // Set Confirm routine. 
                $(document).on('click', '.confirm-disable-girl-delivered', function (e) {
                    e.preventDefault();
                    $('.' + activeToggleClass).prop('checked', false);
                    M2.Modal.close();
                });
            }
        }
    } 

    function setGirlDeliveryToggle() {
        $(document).on('click', '.set-girl-delivery-status', function (e) {
            var $checkbox = $(this);
            var $girlDeliveryStatus = $checkbox.parent().find('.girl-delivery-status');
            if ($checkbox.is(':checked')) $girlDeliveryStatus.val(true);
            else $girlDeliveryStatus.val(false);
        });
    }

    function reIndexAddressBook(frmQuery) {
        const $formRows = $(frmQuery).find('tbody tr');
        $formRows.each(function (contactIndex, elem) {
            const $elem = $(elem);
            $elem.find("input[name]").each(function () {
                const elemIndex = $(this).attr("name").replace(/\D/g, '');
                $(this).attr("name", $(this).attr("name").replace(elemIndex, contactIndex));
            });

            $elem.find("input[id]").each(function () {
                const elemIndex = $(this).attr('id').replace(/\D/g, '');
                $(this).attr('id', $(this).attr('id').replace(elemIndex, contactIndex));
            });

            $elem.find("label[for]").each(function () {
                const elemIndex = $(this).attr('for').replace(/\D/g, '');
                $(this).attr('for', $(this).attr('for').replace(elemIndex, contactIndex));
            });

            $elem.find("span[data-valmsg-for]").each(function () {
                const elemIndex = $(this).attr("data-valmsg-for").replace(/\D/g, '');
                $(this).attr("data-valmsg-for", $(this).attr("data-valmsg-for").replace(elemIndex, contactIndex));
                $(this).html("");
            });
        });
    }

    const gatherEmails = ($collection) => {
        const gatheredEmails = [];
        $collection.each(function () {
            const email = $(this).val();
            if (email !== "") gatheredEmails.push(email.toLowerCase().trim());
        });
        return gatheredEmails;
    }

    const checkForDuplicates = async (email) => {      
        const existingEmails = [];
        const $existingEmailCollection = $("tr:not(.analyzing) .contact-email").find("input");
        existingEmails.push(...gatherEmails($existingEmailCollection));
        return $.inArray(email, existingEmails) !== -1;
    }

    const setCheckforDuplicateEmails = () => {
        $(document).on("blur", ".contact-email input[type='text']", async function () {
            const $emailInput = $(this);
            const email = $emailInput.val();
            const $error = $emailInput.closest("td").find(".duplicate-email-validation-error");
            const $row = $emailInput.closest("tr");
            $row.addClass("analyzing");

            checkForDuplicates(email).then((match) => {
                if (match) {
                    M2.AddressBook.adjustContactCount();
                    $error.removeClass("hidden");
                } else {
                    $error.addClass("hidden");
                }
                $row.removeClass("analyzing");
            });
        });
    }

    const addContactRowInit = ($row) => {
        // Setup validation for form before we add the blank row.
        M2.AddressBook.setupDynamicValidation("#contact-form");

        // Add our contact row.
        M2.AddressBook.addContactRow("", "", $("#exampleGreeting").val(), "", "", false);

        // Set the event on the cloned row.
        M2.AddressBook.setAddContactRow();

        // Remove the last class to hide the delete
        $row.removeClass("last");

        // Clear the default label in Greeting
        M2.Util.clearSearchBox("td.contact-greeting input[type=text]", M2.AddressBook.config.greetingDefaultExampleText);

        // Activate resendEmails
        //resendEmails();
    }

    M2.AddressBook = {
        config: {
            name: "M2 Address Book",
            goalAmount: 12,
            greetingDefaultExampleText: "i.e. Grandma",
            queuedEmailMessageText: "Your email has been queued up to be resent to your contact!",
            deleteEmailWarningTextStart: "You have chosen to delete an email.  You need ",
            deleteEmailWarningTextEnd: " or more emails for best results.  Are you sure you want to proceed?",
            markAsSentId: "#toggle-manual-send",
            markAsSentSwitchId: "mark-sent"
        },
        init: function () {
            setConfigOptions();
            M2.AddressBook.resendEmails();
            M2.AddressBook.setAddContactRow();
            M2.AddressBook.activateContactDeleteRow();
            M2.AddressBook.checkContactCount();
            resetAddAddressOverlay();
            copyToClipBoard("button.copy");
            setMarkAsSent();
            setAgreeToLastName();
            setProductOrderQuery();
            setCheckforDuplicateEmails();
        },

        addressBookOnBegin: function () {
            // on begin
        },
        addressBookOnSuccess: function (result) {
            $.validator.unobtrusive.parse($("#address-book"));

            /* Address Book Update */
            if ($("#HiddenSuccess").val() === "True") {
                M2.Modal.close();
                M2.Util.successMsg();
                M2.Util.setSwitches();
                $(".contact-status:not(:last)").removeClass("queued").addClass(".sent");
            }

            /* Overly Add */
            if ($("#HiddenSuccess_AddOverlay").val() === "True") {
                const addressBookRefreshURL = $("#refresh-address-book-url").val();
                const addOverlayRefreshURL = $("#refresh-add-address-book-url").val();

                $.ajax({
                    url: addOverlayRefreshURL,
                    async: false
                }).done(function (data) {
                    M2.Modal.close();
                    $("#add-addresses-overlay").html(data);  
                });

                $.ajax({
                    url: addressBookRefreshURL
                }).done(function (data) {
                    $("#address-book").html(data);
                    M2.Util.setSwitches();
                    M2.AddressBook.setAddContactRow();
                });
                M2.Util.successMsg();
            }

            if (M2.Util.exists("#address-book")) M2.Util.clearSearchBox("td.contact-greeting input[type=text]", "");
            else M2.Util.clearSearchBox("td.contact-greeting input[type=text]", M2.AddressBook.config.greetingDefaultExampleText);
        },
        contactGoalDifference: function(numberOfContacts) {
            var numberNeeded = M2.AddressBook.config.goalAmount;
            const difference = numberNeeded - numberOfContacts;
            return difference;
        },
        adjustContactCount: function() {
            var count = 0;
            $.each($(".contacts.data tbody .contact-email input[type='text']"), function () {
                /* if ($(this).attr("class") == "valid") count++; */
                if ($(this).val() != "") count++;
            });
            const totalContacts = count;
            const difference = M2.AddressBook.contactGoalDifference(totalContacts);

            if (difference > 0) {
                $("#patch-countdown span").html(difference);
                $("#patch-countdown .earn").show();
                $("#patch-countdown .earned").hide();
            }
            else {
                $("#patch-countdown .earn").hide();
                $("#patch-countdown .earned").fadeIn();
            }
        },
        addContactRow: function (firstname, lastname, greeting, email, source, importing) {
            let newGreeting;
            if (greeting == "i.e. Grandma") newGreeting = greeting;
            else newGreeting = "";

            const $lastRow = $("#imported-contacts:first table.contacts.data tbody tr:last");

            const tmpLineItem = $lastRow.clone();

            tmpLineItem.find("input[id$='_FirstName']").val(firstname);
            tmpLineItem.find("input[id$='_LastName']").val(lastname);
            tmpLineItem.find("input[id$='_Greeting']").val(newGreeting);
            tmpLineItem.find("input[id$='_Email']").val(email);
            tmpLineItem.find("input[id$='_Source']").val(source);
            tmpLineItem.find("input[id$='_SupporterId']").val("");
            tmpLineItem.find("input[id$='_EmailTrackerStatus']").val("");
            tmpLineItem.find("input[id$='_Purchased']").val("False");
            tmpLineItem.find(".duplicate-email-validation-error").addClass("hidden");

            // Checkbox processing
            var $checkbox = tmpLineItem.find("input[type=checkbox]");
            var isgirlDelivered = $checkbox.hasClass('girl-delivery');
            var isLanguageSelection = $checkbox.hasClass('language-selection');

            // Remove any checked boxes, unless it's girl delivery in which case it's always checked and requires a hidden input to be set
            var checkBoxState = isgirlDelivered ? true : false;
            $checkbox.prop("checked", checkBoxState);
            tmpLineItem.find("input[id$='__NutPromiseHidden']").val(checkBoxState);

            if (importing) {
                tmpLineItem.removeClass("last");
                tmpLineItem.insertBefore($lastRow);
            } else {
                tmpLineItem.appendTo('#imported-contacts:first .contacts.data tbody');
            }

            reIndexAddressBook('#imported-contacts');
            M2.Modal.resizeParentIframe();
        },
        setAddContactRow: function () {
            /* Add Contact Row When KeyUp */
            $('#imported-contacts .contacts.data tr:last td.contact-email input').one("keydown", function (e) {
                addContactRowInit($(this).closest("tr"));
            });

            $('.contacts.data tr:last td.contact-email input').blur(function () {
                M2.AddressBook.adjustContactCount();
            });
        },
        resendEmails: function() {       
            $(document).on("click", ".contact-resend a", function (e) {
                e.preventDefault();
                let resendURL = $("#resend-contact-url").val();
                const $supporterId = $(this).parent().parent().find(".contact-firstname input[type='hidden'].supporterid");
                const participantID = parseInt($supporterId.val());
                const $indicator = $(this).parent().parent().find(".contact-status .status");

                if (!isNaN(participantID)) {
                    resendURL = resendURL + "/" + participantID;
                } else {
                    resendURL = resendURL + "/" + 0;
                }

                $.ajax({
                    dataType: "json",
                    url: resendURL,
                    async: false
                }).done(function (data) {
                    if (data.success === true) {
                        $indicator.removeClass();
                        $indicator.addClass("status");
                        $indicator.addClass("queued");
                        $supporterId.val(data.supporter_id);
                        alert(M2.AddressBook.config.queuedEmailMessageText);
                    }
                });
            });
        },
        setupDynamicValidation: function(form) {
            $(form).removeData("validator");
            $(form).removeData("unobtrusiveValidation");
            $.validator.unobtrusive.parse($(form));
        },
        activateContactDeleteRow: function () {
            $(document).on("click", "tr .contact-delete a", function (e) {
                e.preventDefault();
                // If we are in the address book, delete the row from the DB
                if (M2.Util.exists($("#delete-contact-url"))) {
                    var count = 0;

                    $.each($(".contacts.data .contact-email input[type='text']"), function () {
                        if ($(this).val() != "") count++;
                    });

                    const totalContacts = count;
                    const currentRow = $(this).parent().parent();
                    if (totalContacts <= M2.AddressBook.config.goalAmount) {
                        var r = confirm(M2.AddressBook.config.deleteEmailWarningTextStart + M2.AddressBook.config.goalAmount + M2.AddressBook.config.deleteEmailWarningTextEnd);

                        if (r == false) {
                            return false;
                        }
                    }
                    let deleteURL = $("#delete-contact-url").val();
                    const participantID = parseInt($(this).parent().parent().find(".contact-firstname input[type='hidden']").val());
                    if (!isNaN(participantID)) {
                        deleteURL = deleteURL + "/" + participantID;

                        $.ajax({
                            url: deleteURL
                        });
                    }
                    var newCount = totalContacts - 1;
                    // Hide the first delete if there's only one item available
                    if (newCount < 2) $(".contacts.data tbody tr:first").addClass("single");
                    else $(".contacts.data tbody tr:first").removeClass("single");

                }
                $(this).parent().parent().remove();
                M2.AddressBook.adjustContactCount();
                reIndexAddressBook('#imported-contacts');
            });
        },
        checkContactCount: function () {
            // Set bypass to false
            var bypassForm = false;
            $(document).on("click", "#contact-form .tools input[type=button], #contact-form .tools input[type=submit], #address-book-form .address-tools input[type=submit]", function (e) {
                e.preventDefault();
                var self = $(this);
                var frm = self.closest('form');
                var FS = "#" + frm.attr("id"); // Form Selector
                var modalTitle = $(this).data('modal-title');

                let count = 0;
                $.each($(FS + " .contacts.data tbody .contact-email input[type='text']"), function () {
                    /*
                    if ($(this).attr("class") == "valid" && $(this).val() != "") {
                        count++;
                    }
                    */
                    if ($(this).val() != "") count++;
                });
                const totalContacts = count;
                var diff = M2.AddressBook.contactGoalDifference(totalContacts);
                if ($(this).hasClass("launch")) $("#Launch").val("True");
                else $("#Launch").val("False");
                frm.validate();
                /*
                if (frm.valid()) {
                */
                // First Name with hidden inputs
                $(FS + " .data .contact-firstname input[id$='_FirstName']").each(function (index) {
                    $(this).attr("name", "Supporters[" + index + "].FirstName");
                });
                $(FS + " .data .contact-firstname input[id$='_SupporterId']").each(function (index) {
                    $(this).attr("name", "Supporters[" + index + "].SupporterId");
                });
                $(FS + " .data .contact-firstname input[id$='_EmailTrackerStatus']").each(function (index) {
                    $(this).attr("name", "Supporters[" + index + "].EmailTrackerStatus");
                });
                $(FS + " .data .contact-firstname input[id$='_Purchased']").each(function (index) {
                    $(this).attr("name", "Supporters[" + index + "].Purchased");
                });
                // Last Name
                $(FS + " .data .contact-lastname input[id$='_LastName']").each(function (index) {
                    $(this).attr("name", "Supporters[" + index + "].LastName");
                });
                // Greeting
                $(FS + " .data .contact-greeting input[id$='_Greeting']").each(function (index) {
                    $(this).attr("name", "Supporters[" + index + "].Greeting");
                });
                // Email
                $(FS + " .data .contact-email input[id$='_Email']").each(function (index) {
                    $(this).attr("name", "Supporters[" + index + "].Email");
                });

                // Language Selector
                $(FS + " .data .contact-language input[id$='_SendInSpanish']").each(function (index) {
                    $(this).attr("name", "Supporters[" + index + "].SendInSpanish");
                });
                $(FS + " .data .contact-language input[type='hidden']").each(function (index) {
                    $(this).attr("name", "Supporters[" + index + "].SendInSpanish");
                });

                // Nut Promise Checkbox
                $(FS + " .data .contact-nutpromise input[id$='_NutPromise']").each(function (index) {
                    $(this).attr("name", "Supporters[" + index + "].NutPromise");
                });

                // Re-Index VS supplied hidden input for Checkbox
                $(FS + " .data .contact-nutpromise input[type='hidden']").not('.girl-delivery-status').each(function (index) {
                    $(this).attr("name", "Supporters[" + index + "].NutPromise.Value");
                });

                // Contact Delete
                $(FS + " .data .contact-delete input[id$='_Source']").each(function (index) {
                    $(this).attr("name", "Supporters[" + index + "].Source");
                });

   
                if (diff > 0) {
                    $("#proceed-modal .total-emails").html(totalContacts);

                    // Hide the message about entering emails in case we've shown it prior
                    $(".zero-total-emails").hide();

                    if (totalContacts == 0) { // If zero, show the message and the "s" in "emails"
                        $(".zero-total-emails").show();
                        $(".total-plurality").show();
                    } else if (totalContacts == 1) { // if only one, hide the "s" in "emails"
                        $(".total-plurality").hide();
                    } else {
                        $(".total-plurality").show();
                    }

                    if (M2.Util.exists($("#proceed-modal"))) {

                        M2.Modal.create('proceed', modalTitle, '#proceed-modal', null, true);

                        $("#proceed-modal .proceed.btn").unbind('click').click(function () {
                            bypassForm = true;

                            var self = $(this);
                            frm.validate();
                            if (frm.valid()) {
                                self.attr('disabled', 'disabled');
                                frm.submit();
                            }
                            frm.submit();
                        });
                    } else {
                        frm.submit();
                    }
                } else {
                    var $self = $(this);
                    $self.attr('disabled', 'disabled');
                    frm.trigger("submit");
                }
            });
        }
    }
})(jQuery);

$(function () {
    M2.AddressBook.init();
});